import { render, staticRenderFns } from "./PaymentFutureStatementsList.vue?vue&type=template&id=20830b7c&"
import script from "./PaymentFutureStatementsList.vue?vue&type=script&lang=js&"
export * from "./PaymentFutureStatementsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFutureStatementsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports